import React, { Ref, RefObject, useEffect } from "react";
import "./Modal.scss";
import ReactDOM from "react-dom";
import Confetti from 'react-confetti'

interface ModalProps {
    showModal: boolean;
    setShowModal: Function;
    title?: string;
    content: any;
    fixHeight?: boolean;
    full?: boolean;
    minWidth?: string;
    confetti?: boolean;
}

const Modal = (props: ModalProps) => {
    
    const { showModal, setShowModal, title, content, fixHeight, full, minWidth, confetti } = props;

    if (!showModal) return null;

    const handleBackgroundClick = () => {
        setShowModal(false);
    };

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    return ReactDOM.createPortal((
        <div className={"modal" + (fixHeight ? " fixHeight" : "") + (full ? " full" : "")} onClick={handleBackgroundClick}>
            {confetti && <Confetti 
                colors={['#FEE7B0', '#C6C7F8']}
                opacity={0.7}
                numberOfPieces={250}
                recycle={false}
                tweenDuration={10000}
            />}
            <div className="modalContent" style={{minWidth: minWidth ?? '50%'}} onClick={handleContentClick}>
                <div className="top">
                    <h3>{title}</h3>
                    <div onClick={() => setShowModal(false)} className="closeModal"></div>
                </div>
                <div className="content">
                    {content}
                </div>
            </div>
        </div>
    ), document.getElementById("app"));
};

export default Modal;
